var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-scrollbar",
        { staticClass: "scroll_bar" },
        [
          _c(
            "WidgetMenu",
            _vm._g(
              _vm._b(
                {
                  attrs: {
                    data: _vm.widgetMenuFormDataModel,
                    isFixedMenu: true,
                  },
                },
                "WidgetMenu",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }